import {
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser'
import { createContext } from 'react'

const msalConfig = {
  auth: {
    authority:
      process.env.REACT_APP_AUTHORITY ||
      'https://login.microsoftonline.com/heroesinside.com/',
    clientId:
      process.env.REACT_APP_CLIENT_ID || '063f6fb9-38dd-439c-aa0b-e3e6d835ccf0',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
} as Configuration

const tokenRequest = {
  scopes: [
    process.env.REACT_APP_SCOPES || 'api://emos-dev.porsche.com/.default',
  ],
}

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult
    const account = payload.account
    msalInstance.setActiveAccount(account)
  }
})

export const logout = () => {
  msalInstance.logoutRedirect({
    account: msalInstance.getActiveAccount(),
  })
}

export let AccountContext = createContext({
  homeAccount: '',
})

const accounts = msalInstance.getAllAccounts()
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0])
  AccountContext = createContext({
    homeAccount: accounts[0].homeAccountId,
  })
}

export const initMsal = async (onSignedIn: () => void) => {
  msalInstance.handleRedirectPromise().then((resp) => {
    const account = msalInstance.getActiveAccount()
    if (!account) {
      msalInstance.loginRedirect()
    }
    onSignedIn()
  })
}

export const getToken: () => Promise<string> = async () => {
  const account = msalInstance.getActiveAccount()
  if (account) {
    try {
      const authResult = await msalInstance.acquireTokenSilent(tokenRequest)
      return authResult.accessToken
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect(tokenRequest)
        return Promise.reject()
      }
    }
  }
  return Promise.reject()
}
